var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecoverIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7441 2.74408C16.0695 2.41864 16.5972 2.41864 16.9226 2.74408C17.248 3.06951 17.248 3.59715 16.9226 3.92259L16.6785 4.16667L17.7559 5.24408C18.0814 5.56951 18.0814 6.09715 17.7559 6.42259C17.4305 6.74803 16.9028 6.74803 16.5774 6.42259L15.5 5.34518L14.1785 6.66667L15.2559 7.74408C15.5814 8.06951 15.5814 8.59715 15.2559 8.92259C14.9305 9.24803 14.4028 9.24803 14.0774 8.92259L13 7.84518L10.643 10.2022C11.0793 10.8609 11.3333 11.6508 11.3333 12.5C11.3333 14.8012 9.46785 16.6667 7.16667 16.6667C4.86548 16.6667 3 14.8012 3 12.5C3 10.1988 4.86548 8.33333 7.16667 8.33333C8.0159 8.33333 8.8058 8.5874 9.46449 9.02367L12.409 6.07913C12.4096 6.07856 12.4102 6.07798 12.4107 6.07741C12.4113 6.07684 12.4119 6.07627 12.4125 6.0757L14.909 3.57911C14.9096 3.57854 14.9102 3.57798 14.9107 3.57741C14.9113 3.57684 14.9119 3.57628 14.9124 3.57572L15.7441 2.74408ZM7.16667 10C5.78595 10 4.66667 11.1193 4.66667 12.5C4.66667 13.8807 5.78595 15 7.16667 15C8.54738 15 9.66667 13.8807 9.66667 12.5C9.66667 11.1193 8.54738 10 7.16667 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecoverIcon);
export default __webpack_public_path__ + "static/media/recoverIcon.e2d0f90d99ae018d76e95d9db0d25ecf.svg";
export { ForwardRef as ReactComponent };